import MetaTags from "./MetaTags";

export default MetaTags;
